import { useQuery } from "@tanstack/react-query";
import { QueryBuilder } from "features/members";
import { axios } from "lib/axios";

export const getEmployeesPaginated = ({
  churchId,
  isDenomination = false,
  denominationId,
  page,
  pageSize,
  queries
}) => {
  const queryBuilder = new QueryBuilder();

  queryBuilder.pagination(page, pageSize);

  if (queries.search) {
    queryBuilder.search(queries.search);
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/${isDenomination ? "denominations" : "churches"}/${
      isDenomination ? denominationId : churchId
    }/employees-paginated${queryString}`
  );
};

export const useEmployeesPaginated = ({
  churchId,
  isDenomination = false,
  denominationId,
  page,
  pageSize,
  queries = {},
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: [
      "employees",
      page,
      pageSize,
      isDenomination ? denominationId : churchId,
      JSON.stringify(queries)
    ],
    queryFn: () =>
      getEmployeesPaginated({
        churchId,
        isDenomination,
        denominationId,
        page,
        pageSize,
        queries
      })
  });
};
